import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetches {country, count, provinces:[{province,count}]} from the backend.
export default function useRegions() {
  const [regions, setRegions] = useState([]);
  useEffect(() => { api.get("/rodeos/regions").then((r) => setRegions(r.data)).catch(() => {}); }, []);
  return regions;
}
